export default {
  baseUrl: '/api/v2',
  appKey: 'JuSTtOolIsyouRbEsT001',
  orginPassword: 'c42444e588e5573e2bdb46f19259104c8935f0a83aed19b4c8f60f5c97cfb864',
}
